import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import { MAIN_SYSTEM_URL } from '../../config'

if (!window.React) window.React = React
if (!window.ReactDOM) window.ReactDOM = ReactDOM

const BUNDLE_URL = `${MAIN_SYSTEM_URL}/shared-ui/bundle.js?v=${Date.now()}`
const CSS_URL = `${MAIN_SYSTEM_URL}/shared-ui/sonice-shared-ui.css?v=${Date.now()}`

let loaded = false

function loadSharedUI() {
  if (loaded) return Promise.resolve()

  return new Promise((resolve) => {
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = CSS_URL
    document.head.appendChild(link)

    const script = document.createElement('script')
    script.src = BUNDLE_URL
    script.onload = () => { loaded = true; resolve() }
    script.onerror = () => { loaded = true; resolve() }
    document.head.appendChild(script)
  })
}

function useSharedUI() {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    loadSharedUI().then(() => setReady(true))
  }, [])

  return ready ? (window.SoniceSharedUI || {}) : {}
}

export function SharedAppSwitcher(props) {
  const { SubsystemAppSwitcher: Comp } = useSharedUI()
  return Comp ? <Comp {...props} /> : null
}

export function SharedAccountMenu(props) {
  const { SubsystemAccountMenu: Comp } = useSharedUI()
  return Comp ? <Comp {...props} /> : null
}

export function SharedWebhookGuide(props) {
  const { WebhookGuide: Comp } = useSharedUI()
  return Comp ? <Comp {...props} /> : null
}
